import React, { Component } from 'react';
import { withAuth } from '@okta/okta-react';
import { Redirect } from 'react-router';
import Rollbar from 'rollbar';

// This is a modification of the ImplicitCallback component in okta-react
export default withAuth(class WmAuthCallback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: null,
      error: null
    };
  }
  componentDidMount() {
    this.props.auth.handleAuthentication().then(() => this.setState({
      authenticated: true
    })).catch(err => this.errorHandler(err));
  }
  errorHandler(err) {
    if (err.toString() === 'AuthApiError') {
      // Sometimes the okta openid config or keys gets into a bad cached state, this resets them by
      // requestion them with no-cache
      const xmlhttp = new XMLHttpRequest();
      xmlhttp.open('GET', 'https://westernmilling.okta.com/.well-known/openid-configuration', true);
      xmlhttp.setRequestHeader('Access-Control-Allow-Origin', '*');
      xmlhttp.setRequestHeader('Cache-Control', 'no-cache');
      xmlhttp.send();
      const xmlhttp2 = new XMLHttpRequest();
      xmlhttp2.open('GET', 'https://westernmilling.okta.com/oauth2/v1/keys', true);
      xmlhttp2.setRequestHeader('Access-Control-Allow-Origin', '*');
      xmlhttp2.setRequestHeader('Cache-Control', 'no-cache');
      xmlhttp2.send();
    }
    // Send the error to rollbar so we know how often these happen
    this.rollbarError(err.toString());
    this.setState({
      authenticated: false,
      error: err.toString()
    });
  }
  rollbarError(error) {
    new Rollbar({
      accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
      captureUncaught: true,
      captureUnhandledRejections: true,
      payload: {
        environment: process.env.REACT_APP_TITLE_ENV
      }
    }).error(error);
  }
  render() {
    if (this.state.authenticated === null) {
      return null;
    }
    const referrerKey = 'secureRouterReferrerPath';
    const location = JSON.parse(localStorage.getItem(referrerKey) || '{ "pathname": "/" }');
    localStorage.removeItem(referrerKey);
    return this.state.authenticated ? /*#__PURE__*/React.createElement(Redirect, {
      to: location
    }) : /*#__PURE__*/React.createElement("p", null, this.state.error);
  }
});